import {useTranslation} from 'next-i18next';
import PropTypes from 'prop-types';
import React from 'react';
import {Document, Page, pdfjs} from 'react-pdf';

import TextLocal from '@/src/textLocal/containers/TextLocal';

import LoadingIcon from '../../../public/icons/loaing-dark.svg';
import {Button, Separator, Text} from '../../ui';
import css from '../styles/FinishCoursePopUp.module.css';

// to define worker
// https://github.com/wojtekmaj/react-pdf/issues/321#issuecomment-451291757
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const DEFAULT_PAGE_NUMBER = 1;

const FinishCoursePopUpCertificate = ({
  onConfirmClick,
  onCancelClick,
  certificate,
}) => {
  const {t} = useTranslation('common');

  return (
    <div className={css.mainWrapper}>
      <div className={css.header}>
        <Text
          fontSize={Text.FONT_SIZE.SIZE_32}
          fontFamily={Text.FONT_FAMILY.RUBIK}
          fontWeight={Text.FONT_WEIGHT.MEDIUM}
        >
          <TextLocal id={'watchCourse.finish-the-course'} />
        </Text>
      </div>
      <Separator />
      <div className={css.content}>
        <Text
          fontSize={Text.FONT_SIZE.SIZE_24}
          fontFamily={Text.FONT_FAMILY.RUBIK}
          fontWeight={Text.FONT_WEIGHT.MEDIUM}
          lineHeight={Text.LINE_HEIGHT.LINE_HEIGHT_2}
        >
          <TextLocal id={'watchCourse.congratulations'} />
        </Text>
        <Text
          fontSize={Text.FONT_SIZE.SIZE_16}
          fontWeight={Text.FONT_WEIGHT.NORMAL}
          color={Text.COLOR.GREY}
          lineHeight={Text.LINE_HEIGHT.LINE_HEIGHT_32}
        >
          <TextLocal id={'watchCourse.learned-from-best'} />
        </Text>
        <Text
          fontSize={Text.FONT_SIZE.SIZE_16}
          fontWeight={Text.FONT_WEIGHT.NORMAL}
          color={Text.COLOR.GREY}
          lineHeight={Text.LINE_HEIGHT.LINE_HEIGHT_32}
        >
          <TextLocal id={'watchCourse.certificate-has-been-added-to-profile'} />
        </Text>
        <Text
          fontSize={Text.FONT_SIZE.SIZE_16}
          fontWeight={Text.FONT_WEIGHT.NORMAL}
          color={Text.COLOR.GREY}
          lineHeight={Text.LINE_HEIGHT.LINE_HEIGHT_32}
        >
          <TextLocal id={'watchCourse.can-add-certificate-to-cv'} />
        </Text>

        <div className={css.certificateWrapper}>
          <Document
            error={t('validation.failed-to-load-pdf')}
            file={certificate}
            loading={
              <div className={css.certificateLoading}>
                <LoadingIcon />
              </div>
            }
          >
            <Page pageNumber={DEFAULT_PAGE_NUMBER} />
          </Document>
        </div>
      </div>
      <Separator />
      <div className={css.buttons}>
        <div className={css.cancel} onClick={onCancelClick}>
          <Text color={Text.COLOR.GREY}>
            <TextLocal id={'general.cancel'} />
          </Text>
        </div>
        <Button height={Button.HEIGHT.REGULAR} onClick={onConfirmClick}>
          <span className={css.oneLine}>
            <TextLocal id={'watchCourse.got-it'} />
          </span>
        </Button>
      </div>
    </div>
  );
};

FinishCoursePopUpCertificate.propTypes = {
  onConfirmClick: PropTypes.func,
  onCancelClick: PropTypes.func,
  certificate: PropTypes.string.isRequired,
};

export default FinishCoursePopUpCertificate;
